import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-contact-us',
  imports: [
    CommonModule, NgxSpinnerModule, RouterModule
  ],
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactusComponent {

  constructor(private location: Location,
    private router: Router
  ) { }

  onClose() {
    this.router.navigate(['']);
  }
}